import React from 'react';

class TextTruncate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      toExpand: props.text.split(' ').length > 80,
      expand: props.text.split(' ').length > 80
    }
  }

  onChangeExpand = () => this.setState({expand: !this.state.expand});

  truncate = text => {
    let textArr = text.split(' ');
    let truncatedText = '';
    for(let i=0; i<= 70; i++){
      truncatedText += `${textArr[i]}`;
      if(i!==70) truncatedText += ' ';
    }
    return truncatedText;
  };

  render() {
    const {text} = this.props;
    const style = {color:'#337ab7', cursor:'pointer'};

    return (
      !this.state.toExpand ?
        <p style={{whiteSpace:'pre-wrap'}}>{text}</p>:
        !this.state.expand ?
          <div>
            <p style={{whiteSpace:'pre-wrap'}}>{text} <span onClick={this.onChangeExpand} data-toggle="tooltip" title="Hide" className="glyphicon glyphicon-chevron-left icon" style={style}/></p>
          </div>:
          <div>
            <p>{this.truncate(text)}... <span onClick={this.onChangeExpand} data-toggle="tooltip" title="See more" className="glyphicon glyphicon-chevron-right icon" style={style}/></p>
          </div>
    );
  }
}

export default TextTruncate;


// WEBPACK FOOTER //
// ./src/components/common/TextTruncate.js